import axios from 'axios'
import { addNewRmaApiUrl, addNewRmaPostApiUrl } from '@/GlobalConfig/app-config';

class AddRmaSearchList{
    public async getDocumentAddRmaSearchFilter(data){
        let token = localStorage.getItem('token');
        let header = {'Authorization': 'Token '+token};
        const Url = addNewRmaApiUrl;
        return axios({
            method: 'post',
            url: Url,
            data: data,
            headers : header
        });
     }
     public async getDocumentAddSkuList(data){
        let token = localStorage.getItem('token');
        let header = {'Authorization': 'Token '+token};
         const Url = addNewRmaPostApiUrl;
         return axios({
            method:'post',
            url : Url,
            data : data,
            headers : header
         });
     }
}

export const documentAddRmaObj = new AddRmaSearchList();